export default "__VITE_ASSET__ePpcrOKJ__"